goog.provide("shadow.js.shim.module$src$svg$chevron$chevron_up_svg");
goog.provide("module$shadow_js_shim_module$src$svg$chevron$chevron_up_svg");
shadow.js.shim.module$src$svg$chevron$chevron_up_svg = shadow.js.nativeProvides["src/svg/chevron/chevron-up.svg"] = shadow$bridge("src/svg/chevron/chevron-up.svg");
module$shadow_js_shim_module$src$svg$chevron$chevron_up_svg.default = shadow.js.shim.module$src$svg$chevron$chevron_up_svg;
